/*
 * DRIVLY-UI React Components
 * @license MIT
 */
import{isSVGComponent as o}from"./is-svg-component.js";import{createUseRender as r}from"../use-render.js";import{svgMotionConfig as e}from"../../svg/config-motion.js";import{htmlMotionConfig as t}from"../../html/config-motion.js";function n(n,{forwardMotionProps:m=!1},i,s){return{...o(n)?e:t,preloadedFeatures:i,useRender:r(m),createVisualElement:s,Component:n}}export{n as createDomMotionConfig};
//# sourceMappingURL=create-config.js.map
